import React from 'react'
import '../containers/TechSupport.css'
import { Typography, Grid, Paper, Stack } from '@mui/material'
import { MailOutline, Call, LocationOn, AccessTime } from '@mui/icons-material'
import { FormattedMessage } from 'react-intl'

export default function TechSupportContactNA() {
  return (
    <div className='ts-wrapper'>
      <Typography gutterBottom>
        <FormattedMessage id='support.northAmericanOffice' /> (
        <FormattedMessage id='support.northAmericanOffice.countries' />
        ):
      </Typography>
      <Stack spacing={2}>
        <Paper className='ts-paper'>
          <Grid container>
            <Grid item xs={4} className='ts-title-wrapper'>
              <div className='ts-title'>
                <MailOutline color='primary' className='ts-icon' />
                <Typography variant='h6'>
                  <FormattedMessage id='support.emailUs' />
                </Typography>
              </div>
            </Grid>
            <Grid item xs>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.generalInquiries' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>info@gemvision.com</Typography>
                </li>
              </ul>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.technicalSupport' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>support@gemvision.com</Typography>
                </li>
              </ul>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.training' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>training@gemvision.com</Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Paper>
        <Paper className='ts-paper'>
          <Grid container>
            <Grid item xs={4} className='ts-title-wrapper'>
              <div className='ts-title'>
                <Call color='primary' className='ts-icon' />
                <Typography variant='h6'>
                  <FormattedMessage id='support.callUs' />
                </Typography>
              </div>
            </Grid>
            <Grid item xs>
              <Typography variant='subtitle2'>Gemvision</Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>
                    800 357 6272
                    <span className='ts-span'>
                      (<FormattedMessage id='support.tollFree' />)
                    </span>
                  </Typography>
                </li>
                <li>
                  <Typography>
                    +1 563 884 8180
                    <span className='ts-span'>
                      (<FormattedMessage id='support.direct' />)
                    </span>
                  </Typography>
                </li>
                <li>
                  <Typography>
                    888 357 6272
                    <span className='ts-span'>
                      (<FormattedMessage id='support.technicalSupport' />)
                    </span>
                  </Typography>
                </li>
                <li>
                  <Typography>
                    877 619 1889
                    <span className='ts-span'>
                      (<FormattedMessage id='support.fax' />)
                    </span>
                  </Typography>
                </li>
              </ul>
              <Typography variant='subtitle2'>Stuller</Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>+1 800 877 7777</Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Paper>
        <Paper className='ts-paper'>
          <Grid container>
            <Grid item xs={4} className='ts-title-wrapper'>
              <div className='ts-title'>
                <LocationOn color='primary' className='ts-icon' />
                <Typography variant='h6'>
                  <FormattedMessage id='support.directions' />
                </Typography>
              </div>
            </Grid>
            <Grid item xs>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.address' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>302 Rue Louis XIV, Lafayette, LA 70508, USA</Typography>
                </li>
              </ul>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.mailingAddress' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>PO Box 81889, Lafayette, LA 70598</Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Paper>
        <Paper className='ts-paper'>
          <Grid container>
            <Grid item xs={4} className='ts-title-wrapper'>
              <div className='ts-title'>
                <AccessTime color='primary' className='ts-icon' />
                <Typography variant='h6'>
                  <FormattedMessage id='support.schedules' />
                </Typography>
              </div>
            </Grid>
            <Grid item xs>
              <Typography variant='subtitle2'>
                <FormattedMessage id='support.hours' />
              </Typography>
              <ul className='ts-ul'>
                <li>
                  <Typography>
                    <FormattedMessage id='support.monday_friday' />, 8: 00 <small>AM</small> - 7: 00 <small>PM</small>
                    <span className='ts-span'>(UTC-6)</span>
                  </Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Paper>
      </Stack>
    </div>
  )
}
